import { makeSafeQueryRunner } from 'groqd'
import { createClient } from 'next-sanity'

import { SANITY_API_VERSION, SANITY_DATASET, SANITY_PROJECT_ID } from '@/config/env'
import createImageUrlBuilder from '@sanity/image-url'
import type { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'

const projectId = SANITY_PROJECT_ID
const dataset = SANITY_DATASET
const apiVersion = SANITY_API_VERSION

export const client = createClient({
  projectId,
  dataset,
  apiVersion, // https://www.sanity.io/docs/api-versioning
  useCdn: true,
})

export const sanityClientLike = {
  clientConfig: {
    dataset,
    projectId,
  },
  apiVersion, // https://www.sanity.io/docs/api-versioning
  useCdn: true,
}

export const runQuery = makeSafeQueryRunner(async (query, params: Record<string, unknown> = {}) =>
  client.fetch(query, params)
)

export const urlFor = (source: SanityImageSource) => createImageUrlBuilder(client).image(source)

export const generateSrcSet = (urlBuilderObj: ImageUrlBuilder): string => `
  ${urlBuilderObj.url()},
  ${urlBuilderObj.dpr(2).url()} 2x,
  ${urlBuilderObj.dpr(2.5).url()} 2.5x,
  ${urlBuilderObj.dpr(3).url()} 3x,
`
